import { pathWithBaseUrl } from 'libs/constants/routes';

const stripNumbers = (myString: string) => myString.replace(/\D/g, '');

export const principalUrl = pathWithBaseUrl('principal');
export const principalBCPUrl = pathWithBaseUrl('principal-bcp');
export const principalExpUrl = pathWithBaseUrl('principal-experiencia');
export const principalBexUrl = pathWithBaseUrl('principal-bex');

const utils = {
  stripNumbers,
};

export default utils;
